export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 px-4 md:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20warm%20terracotta%20and%20sand%20toned%20abstract%20silk%20fabric%20with%20gentle%20folds%20and%20soft%20dramatic%20lighting%2C%20elegant%20textile%20texture%2C%20no%20text%2C%20high%20end%20editorial%20photography%2C%20rich%20warm%20organic%20curves&width=1800&height=900&seq=cta-full-v4&orientation=landscape"
          alt="Start shopping background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/55"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-background-50 font-heading tracking-wider mb-6">
          START SHOPPING
        </h2>
        <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-10 max-w-xl mx-auto">
          Browse our curated collection of verified Sugargoo spreadsheet links.
          Premium finds, trusted sellers, and safe redirects — all in one place.
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 rounded-full text-sm font-semibold text-background-50 hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center group-hover:bg-primary-400 transition-colors">
            <i className="ri-shopping-bag-line text-white text-base"></i>
          </span>
          <span>VISIT KASPREADSHEET</span>
          <i className="ri-arrow-right-up-line text-sm"></i>
        </a>
      </div>
    </section>
  );
}